package com.devi3east.bashbuddy.features.events.common.data.api

import com.devi3east.bashbuddy.dashboard.responses.PrizeListResponse
import com.devi3east.bashbuddy.features.events.common.data.models.Event
import com.devi3east.bashbuddy.features.events.detail.responses.EventDetailResponse
import com.devi3east.bashbuddy.features.events.feed.responses.EventFeedResponse
import com.devi3east.bashbuddy.footer.requests.ContactFormRequest
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.delete
import io.ktor.client.request.get
import io.ktor.client.request.headers
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.HttpHeaders
import io.ktor.http.contentType
import io.ktor.http.isSuccess

class EventApi(
    private val client: HttpClient,
    private val baseUrl: String
) {

    suspend fun getAllEvents(): EventFeedResponse {
        val response = client.get("$baseUrl/events/all") {
            contentType(ContentType.Application.Json)
        }
        return response.body()
    }

    suspend fun getUserCount(): Int {
        val response = client.get("$baseUrl/users/count") {
            contentType(ContentType.Application.Json)
        }
        return response.body()
    }

    suspend fun getFavoriteEvents(token: String): List<Event> {
        val response = client.get("$baseUrl/events/favorites") {
            headers { append(HttpHeaders.Authorization, "Bearer $token") }
            contentType(ContentType.Application.Json)
        }
        return response.body()
    }

    suspend fun addFavoriteEvent(token: String, eventId: String): Boolean {
        val response = client.post("$baseUrl/events/favorites/add") {
            headers { append(HttpHeaders.Authorization, "Bearer $token") }
            contentType(ContentType.Application.Json)
            setBody(mapOf("eventId" to eventId))
        }
        return response.status.isSuccess()
    }

    suspend fun removeFavoriteEvent(token: String, eventId: String): Boolean {
        val response = client.delete("$baseUrl/events/favorites/remove") {
            headers { append(HttpHeaders.Authorization, "Bearer $token") }
            contentType(ContentType.Application.Json)
            setBody(mapOf("eventId" to eventId))
        }
        return response.status.isSuccess()
    }

    suspend fun getEventById(eventId: String): EventDetailResponse {
        val response = client.get("$baseUrl/events/detail/$eventId") {
            contentType(ContentType.Application.Json)
        }
        return response.body()
    }

    suspend fun getPrizesByEventId(eventId: String): PrizeListResponse {
        val response = client.get("$baseUrl/events/prizes/$eventId") {
            contentType(ContentType.Application.Json)
        }
        return response.body()
    }

    suspend fun sendContactForm(form: ContactFormRequest): Result<String> {
        return try {
            val response= client.post("$baseUrl/contact-form") {
                contentType(ContentType.Application.Json)
                setBody(form)
            }

            if (response.status.isSuccess()) {
                Result.success(response.body())
            } else {
                Result.failure(Exception("Failed: ${response.status}"))
            }
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

}